import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/History_of_Sci_&_Tech_-_Artificial_Intelligence_&_Robotics.png';

function HistoryPageAIAndRobotics() {
  return (
    <TopicPage
      topicKey="Artificial Intelligence & Robotics"
      title="History: Artificial Intelligence & Robotics"
      backgroundImage={bg}
      startRoute="/History-AI-Robotics-Go"
      scrollLabels={[
        "Origins of AI Research",
        "Robotic Automation in Industry",
        "Ethical and Societal Impacts",
      ]}
      backRoute="/history-host"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAIAndRobotics;
